$(function() {
	function progressBarHandler(carousel, progressBar) {
		var count = parseInt(carousel.data('elementCount') || '1') - 1;
		var current = parseInt(carousel.data('elementCurrent') || '0');
		if (count > 0) progressBar.css('width', (current / count) * 100 + '%');
		else if (count == 0) {
			progressBar.css('width', '100%');
		} else {
			progressBar.css('width', '0%');
		}
	}

	function updateCarouselControls(carousel) {
		var current = parseInt(carousel.data('elementCurrent') || '0');
		var prevButton = carousel.find('.pl_igs_carousel_control_prev');
		var nextButton = carousel.find('.pl_igs_carousel_control_next');
		var itemsPerSlide = 3;
		var itemCount = carousel.find('.pl_igs_item').length;
		var effectiveCount = Math.ceil(itemCount / itemsPerSlide);

		if (!prevButton.length && !nextButton.length) return;

		if (effectiveCount <= 1) {
			prevButton.addClass('visually-hidden').prop('disabled', true);
			nextButton.addClass('visually-hidden').prop('disabled', true);
			return;
		}

		prevButton
			.toggleClass('visually-hidden', current <= 0)
			.prop('disabled', current <= 0);
		nextButton
			.toggleClass('visually-hidden', current >= effectiveCount - 1)
			.prop('disabled', current >= effectiveCount - 1);
	}

	function initSportsCarousel() {
		var sportsCarousel = $('*[id*=pl_rfr_carousel]:visible');
		sportsCarousel.each(function() {
			var id = $(this).attr('id');
			var lastChar = id.substr(id.length - 2, 1);
			const pb = $('#pl_igs-pb' + lastChar + '-m');
			if (pb.length) {
				pb.css('width', '10%');
			}
			$(this).data('elementCurrent', 0);
			$(this).data(
				'elementCount',
				$('#' + id + ' .carousel-inner .carousel-item').length
			);
			updateCarouselControls($(this));
			$(this).on('slide.bs.carousel', function(data) {
				$(this).data('elementCurrent', data.to);
				progressBarHandler($(this), pb);
				updateCarouselControls($(this));
			});
		});
	}

	initSportsCarousel();
});
